export const Bio = {
  name: "Rakesh Vejendla",
  roles: [
    "AI Engineer",
    "Mobile App Developer",
    "Full Stack Developer",
  ],
  description:
    "AI Full Stack Engineer with 3+ years of experience building scalable web and mobile applications using React.js, Node.js, and MySQL. Expertise in designing REST APIs, implementing JWT/OAuth authentication, RBAC, and optimizing backend performance with Redis. Experienced in deploying on AWS, Azure, and Railway, with hands-on AI integration using LLM APIs to automate workflows and enhance user experiences.",
  github: "https://github.com/rakeshvejendla333",
  resume: "https://drive.google.com/file/d/1iZmfYXwBf8bsI0O8gobnB4_necdO3WR8/view",
  linkedin: "https://www.linkedin.com/in/vejendlarakesh",
  twitter: "https://twitter.com/",
  insta: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "React.js", image: "https://reactjs.org/logo-og.png" },
      { name: "React Native (Expo)", image: "https://reactnative.dev/img/header_logo.svg" },
      { name: "Redux", image: "https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.png" },
      { name: "Angular", image: "https://www.vectorlogo.zone/logos/angular/angular-icon.svg" },
      { name: "Tailwind CSS", image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" },
      { name: "TypeScript", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg" },
      { name: "JavaScript", image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
      { name: "HTML5", image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png" },
      { name: "CSS3", image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg" },
      { name: "Bootstrap", image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png" },
    ],
  },
  {
    title: "Backend & APIs",
    skills: [
      { name: "Node.js", image: "https://nodejs.org/static/images/logo.svg" },
      { name: "Express.js", image: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png" },
      { name: "FastAPI", image: "https://cdn.worldvectorlogo.com/logos/fastapi.svg" },
      { name: ".NET Core", image: "https://www.vectorlogo.zone/logos/dotnet/dotnet-icon.svg" },
      { name: "C#", image: "https://www.vectorlogo.zone/logos/cnet/cnet-icon.svg" },
      { name: "Python", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
      { name: "REST APIs", image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" },
      { name: "WebSockets", image: "https://upload.wikimedia.org/wikipedia/commons/f/f6/WebSockets_logo.svg" },
    ],
  },
  {
    title: "Databases & Caching",
    skills: [
      { name: "MySQL", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg" },
      { name: "SQL Server", image: "https://www.svgrepo.com/show/303229/microsoft-sql-server-logo.svg" },
      { name: "Firebase Firestore", image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },
      { name: "Redis", image: "https://www.vectorlogo.zone/logos/redis/redis-icon.svg" },
    ],
  },
  {
    title: "Cloud & DevOps",
    skills: [
      { name: "AWS", image: "https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-icon.svg" },
      { name: "Microsoft Azure", image: "https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg" },
      { name: "Railway", image: "https://railway.app/brand/logo-light.svg" },
      { name: "Docker", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg" },
      { name: "Git & GitHub", image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" },
      { name: "CI/CD", image: "https://www.vectorlogo.zone/logos/github/github-icon.svg" },
    ],
  },
  {
    title: "AI & Integration",
    skills: [
      { name: "OpenAI API", image: "https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg" },
      { name: "LLM APIs", image: "https://www.vectorlogo.zone/logos/google/google-icon.svg" },
      { name: "Prompt Engineering", image: "https://cdn.worldvectorlogo.com/logos/fastapi.svg" },
      { name: "RAG (Foundational)", image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
    ],
  },
  {
    title: "Security & Tools",
    skills: [
      { name: "JWT / OAuth", image: "https://www.vectorlogo.zone/logos/auth0/auth0-icon.svg" },
      { name: "RBAC", image: "https://www.vectorlogo.zone/logos/auth0/auth0-icon.svg" },
      { name: "Postman", image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg" },
      { name: "Swagger", image: "https://static1.smartbear.co/swagger/media/assets/images/swagger_logo.svg" },
      { name: "JIRA", image: "https://wac-cdn.atlassian.com/assets/img/favicons/atlassian/favicon.png" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: "AI Full Stack Engineer",
    company: "Tek Advo Inc – Remote",
    date: "Nov 2025 – Present",
    desc: "Led end-to-end development of cross-platform applications across web and mobile, delivering production-ready solutions for Android, iOS, and browser platforms.\nBuilt SplitTek — a full-stack expense-sharing app (similar to Splitwise) with React Native (Expo) for Android/iOS and Node.js backend; implemented group expense tracking, real-time balance calculations, and biometric login.\nBuilt FindStreak — an AI-powered job platform with user workflows, authentication, and scalable backend architecture.\nDesigned and developed scalable REST APIs using Node.js and Express.js with JWT, OAuth, and RBAC.\nIntegrated LLM APIs to enable conversational AI workflows, automated responses, and intelligent user interactions.\nOptimized backend performance using Redis caching, reducing API response times significantly.\nDeployed and managed apps on Railway and AWS, handling DB integration and production releases.\nEnsured security via middleware validation, rate limiting, SQL injection prevention, and XSS protection.",
    skills: [
      "React.js", "React Native (Expo)", "Node.js", "Express.js",
      "MySQL", "AWS", "Railway", "Redis", "JWT", "OAuth", "RBAC",
      "LLM APIs", "Android", "iOS", "Agile"
    ],
  },
  {
    id: 1,
    role: "Full Stack Developer",
    company: "Nebraska Innovation Labs – Omaha, NE",
    date: "Jan 2025 – Oct 2025",
    desc: "Designed and developed full-stack web applications enabling end-to-end workflows for internal operational teams.\nImplemented Redis caching, reducing redundant DB queries and improving API response time by ~40%.\nBuilt real-time features using WebSockets for live session tracking and instant messaging.\nDeveloped responsive admin dashboards using React.js and Tailwind CSS with RBAC and dynamic authorization.\nDesigned audit logging using MySQL triggers to track INSERT, UPDATE, DELETE operations for compliance.\nStructured backend using modular Express.js patterns (controllers, services, models) for scalability.\nImplemented middleware validation and sanitization to prevent SQL injection and XSS vulnerabilities.",
    skills: [
      "React.js", "Redux", "Node.js", "Express.js", "MySQL",
      "Redis", "WebSockets", "Tailwind CSS", "RBAC", "Audit Logging", "Postman"
    ],
  },
  {
    id: 2,
    role: "Research Assistant",
    company: "Northwest Missouri State University – Maryville, MO",
    date: "Aug 2023 – Jun 2024",
    desc: "Designed and developed AI-powered web applications using React.js and FastAPI, enabling real-time conversational user interactions.\nBuilt backend services for AI workflows including request routing, prompt structuring, response validation, and error handling.\nIntegrated LLM APIs to implement context-aware query processing and conversational features.\nDeveloped REST APIs to enable seamless communication between frontend interfaces and backend AI services.\nDeployed and managed applications on Microsoft Azure, optimizing cloud resource usage and reducing infrastructure costs by ~15%.\nParticipated in Agile development, sprint planning, code reviews, and version control using Git.",
    skills: [
      "React.js", "FastAPI", "Python", "LLM APIs", "Microsoft Azure",
      "REST APIs", "Prompt Engineering", "Agile", "Git"
    ],
  },
  {
    id: 3,
    role: "Software Developer",
    company: "Perigord Life Science Solutions – Hyderabad, India",
    date: "Aug 2021 – Mar 2023",
    desc: "Developed enterprise web application modules using Angular, HTML, CSS, and Bootstrap, improving UI responsiveness and cross-browser compatibility.\nBuilt and integrated backend services using C# and .NET Core APIs for seamless data exchange.\nOptimized complex SQL Server queries and stored procedures, improving data retrieval performance by ~30%.\nDeveloped dynamic form validations and reusable frontend components to reduce data entry errors.\nAutomated document generation processes using backend logic and conditional workflows.\nSupported Agile development cycles including bug tracking, issue resolution, and release coordination using JIRA and Azure DevOps.",
    skills: [
      "Angular", "C#", ".NET Core", "SQL Server", "Bootstrap",
      "Postman", "Swagger", "Azure DevOps", "JIRA", "HTML5", "CSS3"
    ],
  },
  {
    id: 4,
    role: "Web Developer Intern",
    company: "Gavita Soft Web Designing Services – India",
    date: "Aug 2020 – Aug 2021",
    desc: "Developed and maintained responsive websites using HTML, CSS, and JavaScript, ensuring cross-browser compatibility and mobile responsiveness.\nCustomized WordPress themes and plugins to support client-specific branding and content management requirements.\nImproved website performance and page load speed through frontend optimizations and efficient asset handling.\nAssisted in implementing SEO best practices including metadata structuring and content optimization.",
    skills: [
      "HTML5", "CSS3", "JavaScript", "WordPress", "SEO", "Responsive Design"
    ],
  }
];

export const education = [
  {
    id: 0,
    img: "https://download.logo.wine/logo/Northwest_Missouri_State_University/Northwest_Missouri_State_University-Logo.wine.png",
    school: "Northwest Missouri State University",
    date: "May 2023 – Jul 2024",
    grade: "Master's Degree",
    desc: "Master of Science in Information Systems. Focused on Business Analysis, Project Management, Object-Oriented Programming, Database Management Systems, and Cybersecurity.",
    degree: "Master of Science in Information Systems",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/thumb/b/b1/QIS_College_of_Engineering_and_Technology_logo.png/200px-QIS_College_of_Engineering_and_Technology_logo.png",
    school: "QIS College of Engineering & Technology",
    date: "May 2017 – Aug 2021",
    grade: "Bachelor's Degree",
    desc: "Bachelor of Technology in Information Technology. Coursework included Data Structures, Algorithms, Object-Oriented Programming, DBMS, Operating Systems, and Computer Networks.",
    degree: "Bachelor of Technology in Information Technology",
  },
];

export const projects = [
  {
    id: 0,
    title: "FindStreak – AI-Powered Job Platform",
    date: "2025 – Present",
    description:
      "Built an AI-powered job search and career platform with automated workflows, intelligent user interactions, and conversational AI. Implements smart job matching, user authentication (JWT/RBAC), and LLM-powered resume analysis and career guidance. Backend built on Node.js/Express.js with MySQL; frontend on React.js.",
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&auto=format&fit=crop&q=60",
    tags: ["React.js", "Node.js", "MySQL", "LLM APIs", "JWT", "OpenAI"],
    category: "web app",
    github: "https://github.com/rakeshvejendla333",
    webapp: "https://findstreak.com",
  },
  {
    id: 1,
    title: "SplitTek – Expense Sharing App",
    date: "2025 – Present",
    description:
      "Full-stack expense-sharing mobile platform (similar to Splitwise) with native apps for Android and iOS built using React Native (Expo). Features group expense tracking, real-time balance calculations, secure authentication (JWT/OAuth), biometric login, and a React (Vite) admin dashboard. Backend: Node.js/Express.js with MySQL on Railway/AWS.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&auto=format&fit=crop&q=60",
    tags: ["React Native", "Expo", "Node.js", "MySQL", "JWT", "Redis", "AWS", "Railway"],
    category: "mobile app",
    github: "https://github.com/rakeshvejendla333",
    webapp: "https://github.com/rakeshvejendla333",
  },
  {
    id: 2,
    title: "AI Code Assistant – LLM Integration Hub",
    date: "2024 – 2025",
    description:
      "Hands-on integration hub demonstrating multi-LLM coding assistance using ChatGPT (GPT-4), Claude AI (Anthropic), Google Gemini, and open-source models via OpenAI-compatible APIs. Implemented chain-of-thought prompt engineering, context management, RAG patterns, and comparative response evaluation across AI providers. Used to accelerate full-stack development workflows.",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&auto=format&fit=crop&q=60",
    tags: ["OpenAI API", "Claude AI", "Google Gemini", "LLM APIs", "Python", "Prompt Engineering", "RAG"],
    category: "AI",
    github: "https://github.com/rakeshvejendla333",
    webapp: "https://www.rakeshvejendla.com",
  },
  {
    id: 3,
    title: "HealthBot AI – Symptom Checker & Wellness Assistant",
    date: "2024",
    description:
      "AI-powered web app providing symptom-based wellness guidance with structured response generation. Backend built using FastAPI for request handling, validation, and AI workflow orchestration. Integrated LLM APIs (Groq LLaMA 3) for context-aware query understanding and response generation. Designed responsive React.js frontend for dynamic rendering of AI-generated health insights.",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&auto=format&fit=crop&q=60",
    tags: ["FastAPI", "Python", "React.js", "LLM APIs", "Groq", "REST APIs"],
    category: "web app",
    github: "https://github.com/rakeshvejendla333",
    webapp: "https://www.rakeshvejendla.com",
  },
  {
    id: 4,
    title: "Real-Time Facial Recognition with Emoji Detection",
    date: "2023",
    description:
      "Computer vision application detecting facial features in real time and mapping expressions to contextual emoji representations. Implemented image processing pipelines using OpenCV for face detection and emotion classification. Stored detection metadata in MySQL for structured logging and analysis. Integrated prototype with a conversational interface to demonstrate interactive AI capabilities.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&auto=format&fit=crop&q=60",
    tags: ["Python", "OpenCV", "MySQL", "Machine Learning", "Computer Vision"],
    category: "machine learning",
    github: "https://github.com/rakeshvejendla333",
    webapp: "https://github.com/rakeshvejendla333",
  },
  {
    id: 5,
    title: "Integrated Waste Management System (IWMS)",
    date: "2022",
    description:
      "Web-based waste tracking system for municipalities and vendors with role-based access and scheduling modules. Developed RESTful .NET Core APIs to manage waste collection, tracking, and reporting workflows in MySQL Server. Included area-based mapping, scheduling, and compliance reporting dashboards.",
    image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&auto=format&fit=crop&q=60",
    tags: ["C#", "ASP.NET", "MySQL", "Swagger", "REST APIs", "RBAC"],
    category: "web app",
    github: "https://github.com/rakeshvejendla333",
    webapp: "https://www.rakeshvejendla.com",
  },
];

export const certifications = [
  {
    id: 0,
    title: "AWS Certified Solutions Architect – Associate",
    issuer: "Amazon Web Services",
    date: "2024",
    image: "https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-icon.svg",
    link: "https://www.credly.com/badges/751f9581-c636-428d-9ce0-8d39901bc6c5/linked_in_profile",
  },
  {
    id: 1,
    title: "Foundational C#",
    issuer: "Microsoft",
    date: "2023",
    image: "https://www.vectorlogo.zone/logos/microsoft/microsoft-icon.svg",
    link: "https://www.freecodecamp.org/certification/fccd94f4e9b-3e0f-44b9-8730-aa0c4bd271f3/foundational-c-sharp-with-microsoft",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started Bachelor's in IT at QIS College" },
  { year: 2020, text: "Web Developer Intern at Gavita Soft" },
  { year: 2021, text: "Graduated B.Tech — Joined Perigord as Software Developer" },
  { year: 2023, text: "Started Master's at Northwest Missouri State University" },
  { year: 2023, text: "Became Research Assistant — Built AI-powered applications" },
  { year: 2024, text: "Graduated M.S. — AWS Certified Solutions Architect" },
  { year: 2025, text: "Full Stack Developer at Nebraska Innovation Labs" },
  { year: 2025, text: "AI Full Stack Engineer at Tek Advo Inc — SplitTek & FindStreak" },
];
